export default __webpack_public_path__ + "static/media/for-business-tests--rounded.c7ef9a87.svg";